<script setup>
defineProps({
    title: String,
    value: String,
    subtitle: String,
    icon: String,
    type: {
        type: String,
        default: 'default'
    },
    iconColor: {
        type: String,
        default: 'indigo'
    }
})
</script>
<template>
    <div class="card">
        <div class="header">
            <span class="title">{{ title }}</span>
            <v-icon :color="iconColor" class="icon">{{ icon }}</v-icon>
        </div>

        <div class="text-black value">{{ value }}</div>

        <div class="footer">
      <span
          class="subtitle"
          :class="{ success: type === 'success' }"
      >
        {{ subtitle }}
      </span>
        </div>
    </div>
</template>
<style scoped>

.card {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* topo */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
}

.icon {
    font-size: 18px;
}

/* valor principal */
.value {
    font-size: 22px;
    font-weight: 700;
    color: #111827;
}

/* rodapé */
.subtitle {
    font-size: 12px;
    color: #6b7280;
}

/* variações */
.subtitle.success {
    color: #16a34a;
}
</style>
